/**
 * DevExtreme (esm/core/utils/position.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import config from "../config";
import {
    isWindow
} from "../utils/type";
const getDefaultAlignment = isRtlEnabled => {
    const rtlEnabled = isRtlEnabled ?? config().rtlEnabled;
    return rtlEnabled ? "right" : "left"
};
const getBoundingRect = element => {
    var _element$getBoundingC;
    if (isWindow(element)) {
        return {
            width: element.outerWidth,
            height: element.outerHeight
        }
    }
    return null === (_element$getBoundingC = element.getBoundingClientRect) || void 0 === _element$getBoundingC ? void 0 : _element$getBoundingC.call(element)
};
export {
    getBoundingRect,
    getDefaultAlignment
};
